import React, { useState } from "react";
import { useSelector } from "react-redux";
import LessonDetails from "./LessonDetails";
// import classes from "./EditLessonWithoutContent.module.css";
import { Stepper, Step } from "../../UI/Stepper";
import ExposeNFinalEditLesson from "./ExposeNFinalLesson";
import { useLocation, useNavigate } from "react-router-dom";


const EditLessonWithoutContent = ({ courseName, tocName, toCParentId, studyGroupId, isProfession, prevToCId }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector((state) => state.application.homeUrl);

    const [data, setData] = useState({
        id: null,
        name: "",
        description: "",
        ideId: null,
        active: true,
        visible: true,
        isLocked: true,
        studyGroupId:studyGroupId
    })
    const location = useLocation()
    const navigate = useNavigate()

    const handleChangeBaseProperties = (name, description, ideId, id) => {
        setData({ ...data, name: name, description: description, ideId: ideId, id: id })
    }

    const handleChangeExposure = (visible) => {
        setData({ ...data, visible: visible })
    }

    const onEnd = () => {
        if (studyGroupId)
            navigate(`${homeUrl}/courses/${studyGroupId}`)
        else
            navigate(`${homeUrl}/courses`)
    }


    return (
        <div>
            <Stepper onEnd={onEnd} title={texts.newLesson} courseName={courseName} tocName={tocName} subTitle={data.name ? data.name : texts.newLesson} arrowOnClick={() => { navigate(-1) }}>
                <Step description={`${texts.details} ${texts.lesson}`} buttonText={texts.saveAndContinue}><LessonDetails handleChangeBaseProperties={handleChangeBaseProperties} data={data} toCParentId={toCParentId} studyGroupId={studyGroupId} isProfession={isProfession} prevToCId={prevToCId} /></Step>
                <Step description={texts.exposeNFinalEditLesson}><ExposeNFinalEditLesson lessonDetails={data} handleChangeExposure={handleChangeExposure}></ExposeNFinalEditLesson></Step>
            </Stepper>
        </div>
    )
}

export default EditLessonWithoutContent;